var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/radio_button_selected.8e0caa0d.png","uri@2x": __webpack_public_path__ + "static/media/radio_button_selected.325e166e.png","uri@3x": __webpack_public_path__ + "static/media/radio_button_selected.b178b1ef.png",
    width: 20,
    height: 20
});